require('./Sentry');
require('./Bootstrap');
require('./Fontello');
require('./Theme');

require('modernizr');
